import { PREFIX_ACTIONS } from './constants';
import { IApiGetDemoDataParam, IApiGetScreensParam, IApiCreateScreenRequest, IUpdateStatusScreenBody } from '../interfaces/api';
import { createAsyncAction, createAction } from 'services/actionConfigs';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const getListScreens = createAsyncAction<IApiGetScreensParam>(PREFIX_ACTIONS + 'getListScreens');
const setScreensParam = createAction<IApiGetScreensParam>(PREFIX_ACTIONS + 'setScreensParam');
const getSummaryStats = createAsyncAction<void>(PREFIX_ACTIONS + 'getSummaryStats');
const createScreen = createAsyncAction<IApiCreateScreenRequest>(PREFIX_ACTIONS + 'createScreen');
const updateStatusScreen = createAsyncAction<IUpdateStatusScreenBody>(PREFIX_ACTIONS + 'updateStatusScreen');

const dashboardActions = {
  getDemoData,
  getListScreens,
  setScreensParam,
  getSummaryStats,
  createScreen,
  updateStatusScreen,
};

export default dashboardActions;

